import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ItemsListTable from "./Components/ItemsListTable";
import {
  GET_ALL_PROCUREMENT_LIST_REQUEST,
  POST_PROCUREMENT_REQUEST,
  PUT_PROCUREMENT_REQUEST,
} from "../../../../../Utils/Constant";
import { useDispatch, useSelector } from "react-redux";

const ProcurementItemsList = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const data = location.state || {};
  const dispatch = useDispatch();

  const handleApproveReject = (status) => {
    dispatch({
      type: PUT_PROCUREMENT_REQUEST,
      payload: { id: data.id, body: { status: status } },
    });
    navigate(-1);
  };

  const handleAddToProcurement = () => {
    dispatch({
      type: POST_PROCUREMENT_REQUEST,
      payload: { id: data.id, type: "procurement" },
    });
    navigate(-1);
  };

  const { loading, addProcurement, updateProcurement, deleteProcurement } =
    useSelector((state) => state.procurement);
  useEffect(() => {
    dispatch({
      type: GET_ALL_PROCUREMENT_LIST_REQUEST,
    });
  }, [dispatch, addProcurement, updateProcurement, deleteProcurement]);

  return (
    <>
      <div className="px-xl-5 px-lg-4 px-3 py-3 page-body">
        <div className="row g-3">
          <div className="col-sm-12">
            <div className="d-flex align-items-center justify-content-between flex-wrap">
              <h3 className="fw-bold mb-0"> Item List</h3>
              <div className="d-flex gap-3 w-sm-100">
                {/* {data.status === "pending" ? (
                  <>
                    <button
                      type="button"
                      className="btn btn-outline-primary"
                      onClick={() => handleApproveReject("approved")}
                    >
                      Approve
                    </button>
                    <button
                      type="button"
                      className="btn btn-danger"
                      onClick={() => handleApproveReject("rejected")}
                    >
                      Reject
                    </button>
                  </>
                ) : data.status === "pending" ? (
                  <>
                    <button
                      type="button"
                      className="btn btn-outline-primary"
                      onClick={() => handleAddToProcurement()}
                    >
                      Add To Procurement
                    </button>
                  </>
                ) : (
                  <>
                    <button
                      type="button"
                      className="btn btn-outline-primary"
                      onClick={() => handleApproveReject("approved")}
                    >
                      Approve
                    </button>
                    <button
                      type="button"
                      className="btn btn-danger"
                      onClick={() => handleApproveReject("rejected")}
                    >
                      Reject
                    </button>
                  </>
                )} */}
                <button
                  type="button"
                  className="btn btn-dark"
                  // data-bs-toggle="offcanvas"
                  // data-bs-target="#add-procurement"
                  // aria-controls="add-procurement"
                  onClick={() => navigate(-1)}
                >
                  Back
                </button>
              </div>
            </div>
          </div>
          <div className="col-sm-12 ">
            <div className="card">
              <div className="card-body ">
                <ItemsListTable data={data} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProcurementItemsList;
